export default "__VITE_ASSET__BW_zkCW7__"